var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstateNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 63,
    viewBox: "0 0 88 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illus-bienneuf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 61.6189H44.3499V52.1689H36.25V61.6189Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.35 7.71918H40.9614C40.9701 7.67557 40.975 7.63049 40.975 7.58418V0.83418C40.975 0.461445 40.6729 0.15918 40.3 0.15918C39.9271 0.15918 39.625 0.461445 39.625 0.83418V7.58418C39.625 7.63049 39.6297 7.67557 39.6386 7.71918H36.25V20.4192H44.35V7.71918Z",
    fill: "#B55436"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 10.2893C40 10.2893 42.325 8.96932 43.6491 14.0499C44.9732 19.1305 44.4591 14.5344 46.7505 15.6704C49.0419 16.8064 46.6212 19.1439 48.4119 18.5872C50.2027 18.0306 50.7045 20.0001 50.7045 20.0001H40V10.2893Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 27_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 51.2893C72 51.2893 74.325 49.9693 75.6491 55.0499C76.9732 60.1305 76.4591 55.5344 78.7505 56.6704C81.0419 57.8064 78.6212 60.1439 80.4119 59.5872C82.2027 59.0306 82.7045 61.0001 82.7045 61.0001H72V51.2893Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 27 Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 10.2891C40 10.2891 37.9962 11.2931 37.0554 14.0496C36.1145 16.8061 36.2454 14.5341 33.954 15.6701C31.6626 16.8061 34.0833 19.1436 32.2925 18.587C30.5018 18.0304 30 19.9998 30 19.9998H40.7045L40 10.2891Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 27 Copy_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 51.2891C18 51.2891 15.9962 52.2931 15.0554 55.0496C14.1145 57.8061 14.2454 55.5341 11.954 56.6701C9.66261 57.8061 12.0833 60.1436 10.2925 59.587C8.50178 59.0304 8.00001 60.9998 8.00001 60.9998H18.7045L18 51.2891Z",
    fill: "#92C281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.575 19.769H29.5V61.619H34.9V51.494C34.9 51.1212 35.2023 50.819 35.575 50.819H45.025C45.3979 50.819 45.7 51.1212 45.7 51.494V61.619H51.1V19.769H45.025H35.575Z",
    fill: "#F6AA5A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fenetre"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.964 30.9509H34.138C33.733 30.9509 33.328 30.6269 33.328 30.1409V30.0599V29.9789V25.5239C33.328 25.0379 33.652 24.7139 34.138 24.7139H45.964C46.126 24.7139 46.288 24.7949 46.45 24.8759C46.774 24.9569 47.017 25.2809 47.017 25.6049V29.9789C47.017 30.3839 46.693 30.7079 46.369 30.7889C46.288 30.8699 46.126 30.9509 45.964 30.9509ZM43.129 29.3309H45.478V26.3339H43.129V29.3309ZM41.428 29.3309H38.998V26.3339H41.428V29.3309ZM34.948 29.3309H37.378V26.3339H34.948V29.3309Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.378 29.331H34.948V26.334H37.378V29.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.428 29.331H38.998V26.334H41.428V29.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.478 29.331H43.129V26.334H45.478V29.331Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fenetre_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.964 38.9509H34.138C33.733 38.9509 33.328 38.6269 33.328 38.1409V38.0599V37.9789V33.5239C33.328 33.0379 33.652 32.7139 34.138 32.7139H45.964C46.126 32.7139 46.288 32.7949 46.45 32.8759C46.774 32.9569 47.017 33.2809 47.017 33.6049V37.9789C47.017 38.3839 46.693 38.7079 46.369 38.7889C46.288 38.8699 46.126 38.9509 45.964 38.9509ZM43.129 37.3309H45.478V34.3339H43.129V37.3309ZM41.428 37.3309H38.998V34.3339H41.428V37.3309ZM34.948 37.3309H37.378V34.3339H34.948V37.3309Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.378 37.331H34.948V34.334H37.378V37.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.428 37.331H38.998V34.334H41.428V37.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.478 37.331H43.129V34.334H45.478V37.331Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fenetre_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.964 46.9509H34.138C33.733 46.9509 33.328 46.6269 33.328 46.1409V46.0599V45.9789V41.5239C33.328 41.0379 33.652 40.7139 34.138 40.7139H45.964C46.126 40.7139 46.288 40.7949 46.45 40.8759C46.774 40.9569 47.017 41.2809 47.017 41.6049V45.9789C47.017 46.3839 46.693 46.7079 46.369 46.7889C46.288 46.8699 46.126 46.9509 45.964 46.9509ZM43.129 45.3309H45.478V42.3339H43.129V45.3309ZM41.428 45.3309H38.998V42.3339H41.428V45.3309ZM34.948 45.3309H37.378V42.3339H34.948V45.3309Z",
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.378 45.331H34.948V42.334H37.378V45.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.428 45.331H38.998V42.334H41.428V45.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.478 45.331H43.129V42.334H45.478V45.331Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7 9.61895H27.45V6.91895H20.7V9.61895Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.025 8.96924H18V61.6192H23.4V16.3942C23.4 16.0215 23.7023 15.7192 24.075 15.7192C24.4477 15.7192 24.75 16.0215 24.75 16.3942V61.6192H30.15V19.0942V8.96924H28.125H20.025Z",
    fill: "#120136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.975 24.494H68.675V19.094H65.975V24.494ZM65.975 31.244H68.675V25.844H65.975V31.244ZM65.975 37.994H68.675V32.594H65.975V37.994ZM65.975 44.744H68.675V39.344H65.975V44.744ZM65.975 51.494H68.675V46.094H65.975V51.494ZM65.975 58.244H68.675V52.844H65.975V58.244ZM61.925 24.494H64.625V19.094H61.925V24.494ZM61.925 31.244H64.625V25.844H61.925V31.244ZM61.925 37.994H64.625V32.594H61.925V37.994ZM61.925 44.744H64.625V39.344H61.925V44.744ZM61.925 51.494H64.625V46.094H61.925V51.494ZM61.925 58.244H64.625V52.844H61.925V58.244ZM57.875 24.494H60.575V19.094H57.875V24.494ZM57.875 31.244H60.575V25.844H57.875V31.244ZM57.875 37.994H60.575V32.594H57.875V37.994ZM57.875 44.744H60.575V39.344H57.875V44.744ZM57.875 51.494H60.575V46.094H57.875V51.494ZM57.875 58.244H60.575V52.844H57.875V58.244ZM53.825 24.494H56.525V19.094H53.825V24.494ZM53.825 31.244H56.525V25.844H53.825V31.244ZM53.825 37.994H56.525V32.594H53.825V37.994ZM53.825 44.744H56.525V39.344H53.825V44.744ZM53.825 51.494H56.525V46.094H53.825V51.494ZM53.825 58.244H56.525V52.844H53.825V58.244ZM50.45 4.13477V19.094V61.619H72.05V18.1112L50.45 4.13477Z",
    fill: "#120136"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M1.50005 61.4998H86.5",
    stroke: "#120136",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstateNewIcon);
export default __webpack_public_path__ + "static/media/estate-new-icon.eda3d329.svg";
export { ForwardRef as ReactComponent };